import { useStore } from 'zustand';
import { createStore } from 'zustand/vanilla';

// Module-level store outside the engine's state controller: the engine replaces node state wholesale on re-init, so state kept here survives while staying observable by the client-owned renderer.
type MobileHealthCardErrorState = {
  message: string | null;
  isLoading: boolean;
};

const initialState: MobileHealthCardErrorState = {
  message: null,
  isLoading: false,
};

const store = createStore<MobileHealthCardErrorState>(() => ({
  ...initialState,
}));

// Bumped on every reset so a reply from an earlier attempt cannot write into a later page visit.
let attempt = 0;

export const useMobileHealthCardErrorMessage = (): string | null =>
  useStore(store, (s) => s.message);

export const useMobileHealthCardLoading = (): boolean =>
  useStore(store, (s) => s.isLoading);

export const setMobileHealthCardLoading = (isLoading: boolean): void => {
  store.setState({ isLoading });
};

export const setMobileHealthCardError = (message: string): void => {
  store.setState({ message, isLoading: false });
};

export const clearMobileHealthCardError = (): void => {
  store.setState({ message: null });
};

export const resetMobileHealthCardErrorStore = (): number => {
  attempt += 1;
  store.setState({ ...initialState });
  return attempt;
};

export const isCurrentMobileHealthCardAttempt = (candidate: number): boolean =>
  candidate === attempt;

export const getMobileHealthCardState = (): MobileHealthCardErrorState =>
  store.getState();
